var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shown ? _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popup__backdrop"
  }), _c('div', {
    staticClass: "popup__panel",
    class: _vm.popup__panel_height
  }, [_vm.showClose ? _c('div', {
    staticClass: "popup__close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32",
      "d": "M368 368L144 144M368 144L144 368"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "popup__header"
  }, [_c('span', {
    staticClass: "popup__header-title"
  }, [_vm.$slots.title ? _vm._t("title") : [_vm._v(_vm._s(_vm.title))]], 2)]), _c('div', {
    staticClass: "popup__body",
    class: _vm.scrolling ? 'scrolling' : ''
  }, [_vm._t("default")], 2), !_vm.noActions ? _c('div', {
    staticClass: "popup__actions"
  }, [_vm._t("actions", function () {
    return [_c('button', {
      staticClass: "s-btn s-btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])];
  }, {
    "close": _vm.close
  })], 2) : _vm._e()])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }